"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: '',
  components: {},
  props: {
    menusList: Array
  },
  data: function data() {
    return {
      list: [],
      actheight1: false,
      actheight: false,
      act: 0,
      job: ''
    };
  },
  methods: {
    getJob: function getJob() {
      console.log(this.job);
      this.$emit('getJob', this.job);
    },
    change: function change(tit, remark, v, j) {
      this.list[j].act = v;
      this.$emit('curLable', tit, remark);
    },
    zhankai: function zhankai(j) {
      this.list[j].actheight = !this.list[j].actheight;
    }
  },
  watch: {
    menusList: {
      handler: function handler(o, n) {
        this.list = this.menusList;
      },
      deep: true
    }
  },
  computed: {},
  created: function created() {
    this.list = this.menusList;
  },
  mounted: function mounted() {}
};